import { getUA } from "react-device-detect";

export const getDeviceUserAgent = () => getUA;
